<template>
  <div>
    <a-skeleton :loading="spinning" active>
      <a-table :columns="columns" :pagination="pagination" :data-source="records" size="middle" row-key="id" @change="handleTableChange">
        <span slot="number" slot-scope="record">{{ record.index }}</span>
        <span slot="operator" slot-scope="operator">{{ operator ? operator.nickname : '系统' }}</span>
        <span slot="diffItem" slot-scope="record">
          <div v-for="(item, key) in record.value_diff" :key="key">{{ item.label }}</div>
        </span>
        <template slot="before" slot-scope="record">
          <span v-for="(item, key) in record.value_diff" :key="key">
            <div v-if="['Title', 'ExpectTime', 'PlanTime', 'DeliveryTime', 'PlanOnlineTime'].includes(item.value)">
              {{ item.before ? item.before : '--' }}
            </div>
            <div v-else-if="item.value === 'Score'">{{ item.before ? requirementScore[item.before - 1].label : '--' }}</div>
            <div v-else-if="item.value === 'ProductLine'">
              {{ Array.isArray(item.before) ? item.before.map(it => productLine[it - 1].label).join(', ') : '--' }}
            </div>
            <div v-else-if="item.value === 'RetrospectType'">
              {{ Array.isArray(item.before) ? item.before.map(it => retrospectType[it].label).join(', ') : '--' }}
            </div>
            <div v-else-if="item.value === 'Priority'">{{ item.after ? brPriority[item.before].label : '--' }}</div>
            <div v-else-if="item.value === 'RequirementType'">{{ item.before ? requirementType[item.before - 1].label : '--' }}</div>
            <div v-else-if="item.value === 'Target'">{{ item.before ? requirementTarget[item.before - 1].label : '--' }}</div>
            <div v-else-if="item.value === 'BusinessDepartment'">{{ item.before ? businessDepartment[item.before - 1].label : '--' }}</div>
            <div v-else-if="['Po', 'TechnicalManager', 'BusinessCorrelation', 'ProductOperation', 'QA'].includes(item.value)">
              <span v-if="item.before && item.before.length > 0">
                <span v-for="(user, index) in item.before" :key="index">
                  <div v-if="userData[user] != null">
                    <a-avatar :size="20" :src="userData[user].avatar_url" /> <span class="nickname">{{ userData[user].nickname }} </span>
                  </div>
                  <div v-else>
                    <a-avatar :size="20" :src="user.avatar_url" /> <span class="nickname">{{ user.nickname }} </span>
                  </div>
                </span>
              </span>
              <span v-else>--</span>
            </div>
            <div v-else-if="['BusinessPartner'].includes(item.value)">
              <div v-if="item.before">
                <div v-if="userData[item.before] != null">
                  <a-avatar :size="20" :src="userData[item.before].avatar_url" /> <span class="nickname">{{ userData[item.before].nickname }} </span>
                </div>
                <div>
                  <a-avatar :size="20" :src="item.before.avatar_url" /> <span class="nickname">{{ item.before.nickname }} </span>
                </div>
              </div>
              <span v-else>--</span>
            </div>
            <div v-else-if="item.value === 'Files'">
              <span v-if="item.before && item.before.length > 0">
                <UploadFile :key="key" :is-edit="false" :data-list.sync="item.before" />
              </span>
            </div>
            <div v-else-if="item.value === 'Images'">
              <span v-if="item.before && item.before.length > 0">
                <UploadImg :key="key" :is-edit="false" :data-list.sync="item.before" />
              </span>
            </div>
            <div v-else-if="item.value === 'IsFactoryModel'">{{ item.before ? '是' : '否' }}</div>
            <div v-else-if="item.value === 'SettlementModel'">{{ item.before ? settlementModel[item.before - 1].label : '--' }}</div>
            <div v-else-if="item.value === 'DesignStatus'">{{ item.before ? requirementDesignStatus[item.before].label : '--' }}</div>
            <div v-else-if="item.value === 'TargetConfig'">
              <span v-if="targetConfigBuild(item).before.gmv !== targetConfigBuild(item).after.gmv"> GMV:{{ targetConfigBuild(item).before.gmv || '--' }} </span>
              <span v-else-if="targetConfigBuild(item).before.workTime !== targetConfigBuild(item).after.workTime"> 工时:{{ targetConfigBuild(item).before.workTime || '--' }} </span>
            </div>
            <div v-else>--</div>
          </span>
        </template>
        <template slot="after" slot-scope="record">
          <span v-for="(item, key) in record.value_diff" :key="key">
            <div v-if="['Title', 'ExpectTime', 'PlanTime', 'DeliveryTime', 'PlanOnlineTime'].includes(item.value)">
              {{ item.after ? item.after : '--' }}
            </div>
            <div v-else-if="item.value === 'Score'">{{ item.after ? requirementScore[item.after - 1].label : '--' }}</div>
            <div v-else-if="item.value === 'ProductLine'">
              {{ Array.isArray(item.after) ? item.after.map(it => productLine[it - 1].label).join(', ') : '--' }}
            </div>
            <div v-else-if="item.value === 'RetrospectType'">
              {{ Array.isArray(item.after) ? item.after.map(it => retrospectType[it].label).join(', ') : '--' }}
            </div>
            <div v-else-if="item.value === 'RequirementType'">{{ item.after ? requirementType[item.after - 1].label : '--' }}</div>
            <div v-else-if="item.value === 'Target'">{{ item.after ? requirementTarget[item.after - 1].label : '--' }}</div>
            <div v-else-if="item.value === 'BusinessDepartment'">{{ item.after ? businessDepartment[item.after - 1].label : '--' }}</div>
            <div v-else-if="['Po', 'TechnicalManager', 'BusinessCorrelation', 'ProductOperation'].includes(item.value)">
              <span v-if="item.after && item.after.length > 0">
                <span v-for="(user, index) in item.after" :key="index">
                  <div v-if="userData[user] != null">
                    <a-avatar :size="20" :src="userData[user].avatar_url" /> <span class="nickname">{{ userData[user].nickname }} </span>
                  </div>
                  <div v-else>
                    <a-avatar :size="20" :src="user.avatar_url" /> <span class="nickname">{{ user.nickname }} </span>
                  </div>
                </span>
              </span>
              <span v-else>--</span>
            </div>
            <div v-else-if="['BusinessPartner'].includes(item.value)">
              <div v-if="item.after">
                <div v-if="userData[item.after] != null">
                  <a-avatar :size="20" :src="userData[item.after].avatar_url" /> <span class="nickname">{{ userData[item.after].nickname }} </span>
                </div>
                <div v-else>
                  <a-avatar :size="20" :src="item.after.avatar_url" /> <span class="nickname">{{ item.after.nickname }} </span>
                </div>
              </div>
              <span v-else>--</span>
            </div>
            <div v-else-if="item.value === 'Files'">
              <span v-if="item.after && item.after.length > 0">
                <UploadFile :key="key" :is-edit="false" :data-list.sync="item.after" />
              </span>
            </div>
            <div v-else-if="item.value === 'Images'">
              <span v-if="item.after && item.after.length > 0">
                <UploadImg :key="key" :is-edit="false" :data-list.sync="item.after" />
              </span>
            </div>
            <div v-else-if="item.value === 'IsFactoryModel'">{{ item.after ? '是' : '否' }}</div>
            <div v-else-if="item.value === 'Priority'">{{ item.after ? brPriority[item.after].label : '--' }}</div>
            <div v-else-if="item.value === 'SettlementModel'">{{ item.after ? settlementModel[item.after - 1].label : '--' }}</div>
            <div v-else-if="item.value === 'DesignStatus'">{{ item.after ? requirementDesignStatus[item.after].label : '--' }}</div>
            <div v-else-if="item.value === 'TargetConfig'">
              <span>
                <span v-if="targetConfigBuild(item).before.gmv !== targetConfigBuild(item).after.gmv"> GMV:{{ targetConfigBuild(item).after.gmv || '--' }} </span>
                <span v-if="targetConfigBuild(item).before.workTime !== targetConfigBuild(item).after.workTime"> 工时:{{ targetConfigBuild(item).after.workTime || '--' }} </span>
              </span>
            </div>
            <div v-else>--</div>
          </span>
        </template>
      </a-table>
    </a-skeleton>
    <preview-modal ref="previewModal" />
  </div>
</template>

<script>
import { userList } from '@/api/system/auth';
import { queryRecords } from '@/api/business/requirement';
import { requirementScore, requirementTarget, settlementModel, requirementType, productLine, requirementStatus, requirementDesignStatus, brPriority, retrospectType } from '@/utils/dictionary';

import PreviewModal from '@/pages/project/components/PreviewModal';
import UploadImg from '@/pages/business/requirement/components/UploadImg';
import UploadFile from '@/pages/business/requirement/components/UploadFile';

const columns = [
  {
    title: '序号',
    width: '5%',
    align: 'center',
    scopedSlots: { customRender: 'number' }
  },
  {
    title: '操作人',
    width: '10%',
    align: 'center',
    dataIndex: 'operator',
    key: 'operator',
    scopedSlots: { customRender: 'operator' }
  },
  {
    title: '操作时间',
    width: '15%',
    align: 'center',
    key: 'created_time',
    dataIndex: 'created_time'
  },
  {
    title: '变更类型',
    width: '10%',
    align: 'center',
    key: 'operation_alias',
    dataIndex: 'operation_alias'
  },
  {
    title: '变更项',
    width: '10%',
    align: 'center',
    scopedSlots: { customRender: 'diffItem' }
  },
  {
    title: '变更前',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'before' }
  },
  {
    title: '变更后',
    align: 'center',
    width: '25%',
    scopedSlots: { customRender: 'after' }
  }
];
export default {
  components: { PreviewModal, UploadImg, UploadFile },
  props: {
    sourceId: {
      type: [Number, String],
      default: null
    },
    ticketTagList: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      userData: [],
      columns,
      brPriority,
      retrospectType,
      requirementDesignStatus,
      requirementScore,
      requirementTarget,
      settlementModel,
      requirementType,
      productLine,
      requirementStatus,
      spinning: true,
      projectId: parseInt(this.$route.params.project_id) || null,
      records: [],
      pagination: {
        size: 'small',
        total: 0,
        pageSize: this.$store.getters.pageSize, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      recordItems: {
        Title: { value: 'Title', label: '标题' },
        Score: { value: 'Score', label: '需求打分' },
        ProductLine: { value: 'ProductLine', label: '涉及产品线' },
        RequirementType: { value: 'RequirementType', label: '需求分类' },
        Target: { value: 'Target', label: '	需求目的' },
        BusinessPartner: { value: 'BusinessPartner', label: '主业务方' },
        BusinessDepartment: { value: 'BusinessDepartment', label: '业务部门' },
        BusinessCorrelation: { value: 'BusinessCorrelation', label: '关联业务方' },
        Po: { value: 'Po', label: '产品Po' },
        QA: { value: 'qa', label: '质量' },
        Files: { value: 'Files', label: '文件' },
        Images: { value: 'Images', label: '图片' },
        status: { value: 'status', label: '状态' },
        TechnicalManager: { value: 'TechnicalManager', label: '技术经理' },
        ProductOperation: { value: 'ProductOperation', label: '产品运营' },
        IsFactoryModel: { value: 'IsFactoryModel', label: '厂长制' },
        SettlementModel: { value: 'SettlementModel', label: '	结算方式' },
        ExpectTime: { value: 'ExpectTime', label: '期望上线时间' },
        TargetConfig: { value: 'TargetConfig', label: '价值配置' },
        DesignStatus: { value: 'DesignStatus', label: '设计状态' },
        PlanTime: { value: 'PlanTime', label: '计划时间' },
        PlanOnlineTime: { value: 'PlanOnlineTime', label: '预计交付时间' },
        DeliveryTime: { value: 'DeliveryTime', label: '交付时间' },
        Priority: { value: 'Priority', label: '优先级' },
        RetrospectType: { value: 'RetrospectType', label: '追溯类型' }
      }
    };
  },
  computed: {
    businessDepartment() {
      return this.$store.getters.globalConfig('business_department', []);
    },
    targetConfigBuild() {
      return data => {
        const obj = JSON.parse(JSON.stringify(data || {}));
        if (!obj.before) {
          obj['before'] = {};
        }
        if (!obj.after) {
          obj['after'] = {};
        }
        console.log(obj);
        return obj;
      };
    },
    diff() {
      return data => {
        const items = [];
        const itemKeys = Object.keys(this.recordItems);
        for (const key in data) {
          if (itemKeys.includes(key)) {
            items.push({
              ...this.recordItems[key],
              ...data[key]
            });
          }
        }
        return items;
      };
    }
  },
  created() {
    if (this.sourceId !== null) this.getProblemRecord();
    this.getUserList();
  },
  methods: {
    getTagTitle(key) {
      const node = this.findNodeByKey(this.ticketTagList, key);
      if (node) {
        return node.title;
      }
      return '';
    },
    getUserList() {
      userList({ return_type: 'dict' }).then(res => {
        this.userData = res.data.users;
      });
    },
    findNodeByKey(tree, key) {
      for (const node of tree) {
        if (node.key === key) {
          return node;
        }
        if (node.children) {
          const foundNode = this.findNodeByKey(node.children, key);
          if (foundNode) {
            return foundNode;
          }
        }
      }
      return null;
    },
    getProblemRecord() {
      queryRecords({
        source_id: this.sourceId,
        source_name: 'business_req',
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      })
        .then(res => {
          this.pagination.total = res.data.total;
          this.records = res.data.items.map((record, index) => {
            return {
              index: index + 1,
              ...record,
              value_diff: this.diff(record.value_diff)
            };
          });
          this.spinning = false;
        })
        .catch(() => {
          this.spinning = false;
        });
    },
    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getProblemRecord();
    },
    onPreview(content, title) {
      this.$nextTick(() => {
        this.$refs.previewModal.onOpen(content, title);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.diff-item {
  display: block;
}

.ql-container.ql-snow {
  border: none;
}
</style>
